import { createIcon } from '@chakra-ui/react';

export const StatsSyncIcon = createIcon({
  displayName: 'StatsSyncIcon',
  viewBox: '0 0 48 48',
  defaultProps: {
    fill: 'none',
    height: '48',
    width: '48',
  },
  path: (
    <>
      <circle cx="24" cy="24.7754" r="24" fill="#EFFCF6" />
      <path
        d="M24 11.4424C31.3637 11.4424 37.3328 17.4117 37.333 24.7754C37.333 32.1392 31.3638 38.1084 24 38.1084C16.6364 38.1082 10.667 32.1391 10.667 24.7754C10.6672 17.4119 16.6365 11.4426 24 11.4424ZM28.2588 18.9473L22.624 28.8057L19.668 24.667L18.8926 23.582L16.7227 25.1318L17.498 26.2168L21.2109 31.415C21.9882 32.503 23.6315 32.4197 24.2949 31.2588L30.5742 20.2695L31.2354 19.1123L28.9199 17.7891L28.2588 18.9473Z"
        fill="#147D64"
      />
    </>
  ),
});
